import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

interface CustomSearchState {
  [key: string]: any;
}

const initialState: CustomSearchState = {};

const customSearchSlice = createSlice({
  name: "customSearchData",
  initialState,
  reducers: {
    setCustomSearchData: (state, action: PayloadAction<CustomSearchState>) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(),
      };
    },
  },
});

export const { setCustomSearchData } = customSearchSlice.actions;

export default customSearchSlice.reducer;

export const getSearchData = (state: { customSearchData: CustomSearchState }) =>
  state.customSearchData;

export const useCustomSearchData = () => {
  return useSelector(getSearchData);
};
